"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfig = exports.useConfigDispatch = exports.useConfigState = exports.ConfigProvider = exports.initialState = void 0;

var _react = require("react");

var _reducer = require("./reducer");

var _factory = require("../../factory");

var _routes = require("../../../utils/routes");

const initialState = {
  active: {},
  activeProject: undefined,
  insightType: _routes.InsightType.Insights,
  isLoading: false,
  pristine: true,
  isSaving: false,
  saved: {},
  selectedRule: undefined,
  shouldReset: false
};
exports.initialState = initialState;
const stateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const dispatchContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const ConfigProvider = (0, _factory.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.ConfigProvider = ConfigProvider;
const useConfigState = (0, _factory.createStateHook)(stateContext);
exports.useConfigState = useConfigState;
const useConfigDispatch = (0, _factory.createDispatchHook)(dispatchContext);
exports.useConfigDispatch = useConfigDispatch;
const useConfig = (0, _factory.createContextHook)(stateContext, dispatchContext);
exports.useConfig = useConfig;